import { useEffect, useState } from "react";
import style from "./AdminIot.module.css";
import clsx from "classnames";
import axios from "axios";
import { adjustDevice, getCookie, storeTokens } from "shared/utils/IotUtils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import SquareWrapper from "layouts/wrapper/SquareWrapper";
import Center from "layouts/wrapper/Center";


function IoTDevice(props) {
    const minBrightness = 0;
    const maxBrightness = 996;
    const minColorTemp = 1000;
    const maxColorTemp = 34882;

    const { data: device, onDeviceChanged } = props;
    const checkState = () => {
        return device.data.state.toString().toLowerCase() === "true" ? true : false;
    }
    const [isOn, setIsOn] = useState(checkState());
    const [brightness, setBrightness] = useState(device.data.brightness || 0);

    const [colorTemp, setColorTemp] = useState(device.data.color_temp || 0);
    const [displayBrightness, setDisplayBrightness] = useState(Math.round((device.data.brightness - minBrightness) / (maxBrightness - minBrightness) * 100));
    const [displayColorTemp, setDisplayColorTemp] = useState(Math.round((device.data.color_temp - minColorTemp) / (maxColorTemp - minColorTemp) * 100));



    const handleToggle = () => {
        const newState = isOn ? 0 : 1; // 토글 상태 변경

        adjustDevice(device.id, "turnOnOff", "value", newState, (result) => {
            if (result?.header?.code === "SUCCESS") {
                const updatedDevice = {
                    ...device,
                    data: {
                        ...device.data,
                        state: !isOn
                    }
                };
                onDeviceChanged(updatedDevice);
                setIsOn(!isOn);
            } else {
                console.error("Failed to update device state");
            }
        });
    };

    const handleBrightnessChange = (event) => {
        const newBrightness = parseInt(event.target.value, 10);
        setBrightness(newBrightness); // 슬라이더 값만 업데이트 (API 요청 없음)
    };

    const handleBrightnessChangeEnd = () => {
        let expectedValue = Math.round((brightness - minBrightness) / (maxBrightness - minBrightness) * 100);
        let adjustValue = Math.round((expectedValue * 0.9) + 10);

        adjustDevice(device.id, "brightnessSet", "value", adjustValue, (result) => {
            console.log("result", result);
            if (result?.header?.code === "SUCCESS") {
                const updatedDevice = {
                    ...device,
                    data: {
                        ...device.data,
                        brightness: brightness,
                    },
                };
                setDisplayBrightness(expectedValue);
                onDeviceChanged(updatedDevice);
            } else {
                console.error("Failed to update brightness");
            }
        });
    };

    const handleColorTempChange = (event) => {
        const newColorTemp = parseInt(event.target.value, 10);
        setColorTemp(newColorTemp); // 슬라이더 값만 업데이트 (API 요청 없음)
    };

    const handleColorTempChangeEnd = () => {
        let expectedValue = Math.round((colorTemp - minColorTemp) / (maxColorTemp - minColorTemp) * 100);
        let adjustValue = Math.round((expectedValue * 90) + 1000);
        // let adjustValue = Math.round(((colorTemp - 1000) / 4.033) + 1000);
        adjustDevice(device.id, "colorTemperatureSet", "value", adjustValue, (result) => {
            console.log("result", result);
            if (result?.header?.code === "SUCCESS") {
                const updatedDevice = {
                    ...device,
                    data: {
                        ...device.data,
                        color_temp: Math.round(colorTemp * 1.04),
                    },
                };
                setDisplayColorTemp(expectedValue);
                onDeviceChanged(updatedDevice);
            } else {
                console.error("Failed to update brightness");
            }
        });
    };


    return (
        <div>
            {device && (
                <div className={style.device}>
                    {/* <div className={style.mask}>
                    </div> */}
                    <VerticalFlex gap={10} height={"100%"}>
                        {/* <FlexChild>
                            <div>{device.id}</div>
                        </FlexChild> */}
                        <FlexChild>
                            <HorizontalFlex jusifyContent={"space-between"}>
                                <FlexChild>
                                    <div>
                                        <img className={style.deviceIcon} src={device.icon} alt={device.name} />
                                    </div>
                                </FlexChild>
                                <FlexChild width={"initial"}>
                                    {
                                        !device.data.online &&
                                        <div>
                                            <FontAwesomeIcon icon={fas["faPlugCircleXmark"]} color={"red"} />
                                        </div>
                                    }
                                </FlexChild>
                            </HorizontalFlex>
                        </FlexChild>
                        <FlexChild>
                            <div>
                                <strong>{device.name}</strong>
                            </div>
                        </FlexChild>
                        {/* <FlexChild>
                            <div>{device.dev_type}</div>
                        </FlexChild> */}
                        {/* <FlexChild>
                            <div>
                                {device.data && Object.keys(device.data).length > 0 ? (
                                    <VerticalFlex>
                                        {Object.entries(device.data).map(([key, value]) => (
                                            <FlexChild key={key}>
                                                <HorizontalFlex gap={10}>
                                                    <FlexChild width={"initial"}>
                                                        <strong>{key}</strong>
                                                    </FlexChild>
                                                    <FlexChild>
                                                        {value.toString()}
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </FlexChild>
                                        ))}
                                    </VerticalFlex>
                                ) : (
                                    <p>No data available</p>
                                )}
                            </div>
                        </FlexChild> */}
                        <FlexChild>
                            <div className={style.deviceControls}>
                                {device.dev_type === "light" && (
                                    <div>
                                        <VerticalFlex gap={10}>
                                            <FlexChild>
                                                <HorizontalFlex>
                                                    <FlexChild width={30}>
                                                        <Center>
                                                            <FontAwesomeIcon icon={far["faSun"]} />
                                                        </Center>
                                                    </FlexChild>
                                                    <FlexChild>
                                                        <input
                                                            className={style.sliderBrightness}
                                                            type="range"
                                                            min="0"
                                                            max="996"
                                                            value={brightness}
                                                            onChange={handleBrightnessChange} // 값 변경만 처리
                                                            onMouseUp={handleBrightnessChangeEnd} // 마우스에서 손을 뗄 때 API 호출
                                                            onPointerUp={handleBrightnessChangeEnd} // 모바일 터치 종료 시 API 호출
                                                        />
                                                    </FlexChild>
                                                    <FlexChild width={30}>
                                                        <Center>
                                                            {displayBrightness}
                                                        </Center>
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </FlexChild>
                                            <FlexChild>
                                                {
                                                    device.data.color_temp &&
                                                    <HorizontalFlex>
                                                        <FlexChild width={30}>
                                                            <Center>
                                                                <FontAwesomeIcon icon={fas["faTemperatureHalf"]} />
                                                            </Center>
                                                        </FlexChild>
                                                        <FlexChild>
                                                            <input
                                                                className={style.sliderColorTemp}
                                                                type="range"
                                                                min="0"
                                                                max="34882"
                                                                value={colorTemp}
                                                                onChange={handleColorTempChange} // 값 변경만 처리
                                                                onMouseUp={handleColorTempChangeEnd} // 마우스에서 손을 뗄 때 API 호출
                                                                onPointerUp={handleColorTempChangeEnd} // 모바일 터치 종료 시 API 호출
                                                            />
                                                        </FlexChild>
                                                        <FlexChild width={30}>
                                                            <Center>
                                                                {displayColorTemp}
                                                            </Center>
                                                        </FlexChild>
                                                    </HorizontalFlex>
                                                }
                                            </FlexChild>
                                        </VerticalFlex>
                                    </div>
                                )}
                            </div>
                        </FlexChild>
                        <FlexChild />
                        <FlexChild>
                            <div>
                                <div className={style.toggleSwitch} onClick={handleToggle}>
                                    <div className={clsx(style.switch, { [style.on]: isOn, [style.off]: !isOn })} />
                                </div>
                            </div>
                        </FlexChild>
                    </VerticalFlex>
                </div>
            )}
        </div>
    );
}

export default IoTDevice;
